import { Button, Stack, Typography } from '@mui/material';
import { KeyboardEvent } from 'react';

interface IRadioButtons {
  options: string[];
  setValue: React.Dispatch<React.SetStateAction<string>>;
  value: string;
  labelledby: string;
}

export const RadioButtons = ({
  options,
  setValue,
  value,
  labelledby,
}: IRadioButtons) => {
  const handleThoughtsKeyDown = (
    e: KeyboardEvent<HTMLButtonElement>,
    index: number
  ) => {
    switch (e.key) {
      case ' ':
      case 'Enter':
        e.preventDefault();
        setValue(options[index]);
        break;
      case 'ArrowDown':
      case 'ArrowLeft':
        e.preventDefault();
        const nextIndex = index + 1 < options.length ? index + 1 : 0;
        const nextButton = document.getElementById(
          options[nextIndex].replaceAll(' ', '-')
        );
        nextButton?.focus();
        break;
      case 'ArrowUp':
      case 'ArrowRight':
        e.preventDefault();
        const prevIndex = index - 1 >= 0 ? index - 1 : options.length - 1;
        const prevButton = document.getElementById(
          options[prevIndex].replaceAll(' ', '-')
        );
        prevButton?.focus();
        break;
      default:
        break;
    }
  };

  return (
    <Stack
      sx={{ flexDirection: 'row', gap: '16px' }}
      aria-labelledby={labelledby}
      role='radiogroup'
    >
      {options.map((option, index) => (
        <Button
          key={option.replaceAll(' ', '-')}
          variant='secondary'
          sx={{
            border: '1px solid',
            borderColor: 'primary.shade_100',
            p: '8px 12px',
            bgcolor: value === option ? 'primary.main' : 'white',
            color: value === option ? 'white' : 'primary.main',
            ':focus': {
              bgcolor: 'primary.main',
              color: 'white',
              border: 'none',
            },
          }}
          onClick={() => {
            setValue(option);
          }}
          role='radio'
          aria-checked={value === option}
          onKeyDown={(e) => handleThoughtsKeyDown(e, index)}
          id={option.replaceAll(' ', '-')}
        >
          <Typography variant='body6'>{option}</Typography>
        </Button>
      ))}
    </Stack>
  );
};
